import 'babel-polyfill';
import 'intl';
import 'intl/locale-data/jsonp/en';
import 'intl/locale-data/jsonp/zh';
import 'intl/locale-data/jsonp/th';
import 'intl/locale-data/jsonp/id';
import 'intl/locale-data/jsonp/ja';
import 'intl/locale-data/jsonp/ko';
import 'intl/locale-data/jsonp/vi';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './styles/incredible/incredible.css';
import './styles/aos.css';
import App from './App';
import unregister from './registerServiceWorker';
import { HashRouter, Route } from 'react-router-dom';
import { createStore, compose, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import localforage from 'localforage';
import { persistCombineReducers, persistStore, REHYDRATE, PERSIST } from 'redux-persist';
import { PersistGate } from 'redux-persist/es/integration/react';
import ReactLoading from 'react-loading';
import { StorageConfig } from './configs';
import LocalesReducer from './reducers/locales';
import UIReducer from './reducers/ui';
import axios from 'axios';
import * as UIActions from './actions/ui';
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';
import th from 'react-intl/locale-data/th';
import id from 'react-intl/locale-data/id';
import ja from 'react-intl/locale-data/ja';
import ko from 'react-intl/locale-data/ko';
import vi from 'react-intl/locale-data/vi';
import localeData from './locales/output/translation.json';
import ConnectedIntlProvider from './Components/ConnectedIntlProvider';
import { LocalesActions } from './reducers/locales';

addLocaleData([...en, ...zh, ...th, ...id, ...ja, ...ko, ...vi]);

const composeEnhancers = process.env.NODE_ENV === 'development' ? (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose) : compose;


/** store initialization **/
localforage.config(StorageConfig);
let storeRehydrating = true;
const storageMiddleware = (store) => (next) => (action) => {
    if (action.type === REHYDRATE || action.type === PERSIST || storeRehydrating) {
        return next(action);
    }
    const stampedAction = {
        action,
        timeStamp: Date.now()
    };

    localStorage.setItem('LAST-ACTION', JSON.stringify(stampedAction));

    next(action);
};

const middleware = [thunk, storageMiddleware];
const reducer = persistCombineReducers({
    key: 'root',
    storage: localforage,
    debug: process.env.NODE_ENV === 'development'
}, {
    ui: UIReducer,
    locales: LocalesReducer,
});
export const store = createStore(
    reducer,
    composeEnhancers(
        applyMiddleware(...middleware)
    )
);

/** axios interceptors **/
axios.interceptors.request.use((config) => {
    const { locales } = store.getState();
    let locale = locales.locale || 'en';

    let headers = {
        "Accept-Language": locale
    };

    config.headers = {
        ...headers,
        ...config.headers
    };
    return config
}, (error) => {
    let err = error.response && error.response.data ? error.response.data : error;
    store.dispatch(UIActions.addError(err));
    store.dispatch(UIActions.appReady());
    return Promise.reject(err)
});

axios.interceptors.response.use((response) => {
    return response
}, (error) => {
    let err = error.response && error.response.data ? error.response.data : error;
    if (err.code !== 'INVALID_DATA' && err.message !== "Booking is not active") {
        store.dispatch(UIActions.addError(err));
    }
    store.dispatch(UIActions.appReady());
    return Promise.reject(err)
});

const persistor = persistStore(store, null, () => {
    // force locale to reload messages
    const { locales } = store.getState();
    const langArray = ['en', 'ko', 'zh', 'id', 'th'];
    let lang = locales.locale || navigator.language || navigator.browserLanguage;
    lang = lang.substring(0, 2);
    if (langArray.indexOf(lang) === -1) {
        lang = 'en';
    }
    changeLocale(lang);
    storeRehydrating = false;
});

/** i18n **/
let locale = localStorage.getItem('locale') || 'en';
let messages = localeData[locale] || localeData.en;

export const changeLocale = (newLocale) => {
    if (!newLocale) return;
    localStorage.setItem('locale', newLocale);
    locale = newLocale;
    messages = localeData[locale] || localeData.en;
    store.dispatch({
        type: LocalesActions.UPDATE_LOCALE,
        locale,
        messages
    })
};


ReactDOM.render(
    <Provider store={store}>
        <PersistGate
            loading={<ReactLoading />}
            persistor={persistor}>
            <ConnectedIntlProvider>
                <HashRouter>
                    <Route path="/" component={App} />
                </HashRouter>
            </ConnectedIntlProvider>
        </PersistGate>
    </Provider>,
    document.getElementById('root'));
unregister();
